import React, { Component } from 'react';

export default class Search extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M52.254,57.452c-4.921,3.798 -11.089,6.058 -17.78,6.058c-16.084,0 -29.142,-13.058 -29.142,-29.142c0,-16.084 13.058,-29.141 29.142,-29.141c16.084,0 29.142,13.057 29.142,29.141c0,6.692 -2.261,12.859 -6.058,17.781l16.215,16.216c2.233,2.371 0.03,7.414 -3.767,6.231c-0.553,-0.172 -0.861,-0.293 -1.536,-0.928l-16.216,-16.216Zm-17.78,-46.079c12.691,0 22.995,10.304 22.995,22.995c0,12.692 -10.304,22.996 -22.995,22.996c-12.692,0 -22.996,-10.304 -22.996,-22.996c0,-12.691 10.304,-22.995 22.996,-22.995Z"/>
              </g>
            </svg>
        )
    }
}
